import { z } from 'zod';
/**
 * The eight normalized post metrics of module 120 (spec 120 §4,
 * REQ-120-002). Platform metric names never appear here: the worker's metric
 * map translates them. `null` means "the platform did not provide it for this
 * post", never 0 (REQ-ANA-004).
 */
export const ANALYTICS_METRIC_KEYS = ['reach', 'impressions', 'reactions', 'comments', 'shares', 'saves', 'video_views', 'profile_activity'];
const metricValue = z.number().int().nonnegative().nullable();
export const analyticsNormalizedMetricsSchema = z.strictObject(Object.fromEntries(ANALYTICS_METRIC_KEYS.map((key) => [key, metricValue])));
/** Platform metric name → the value exactly as returned (a number, or an object of numbers for breakdowns such as reaction types). */
const rawValue = z.union([z.number(), z.record(z.string().max(100), z.number())]);
/** `analytics_snapshots.metrics` (spec 120 §4): every `null` key of `normalized` is listed in `unavailable`, and only those. */
export const analyticsSnapshotMetricsSchema = z
    .strictObject({
    normalized: analyticsNormalizedMetricsSchema,
    unavailable: z.array(z.enum(ANALYTICS_METRIC_KEYS)).max(ANALYTICS_METRIC_KEYS.length),
    raw: z.record(z.string().min(1).max(100), rawValue),
})
    .refine((metrics) => {
    const missing = ANALYTICS_METRIC_KEYS.filter((key) => metrics.normalized[key] === null);
    return missing.length === metrics.unavailable.length && missing.every((key) => metrics.unavailable.includes(key));
}, { message: 'unavailable must list exactly the null metrics', path: ['unavailable'] });
/** The tenant cycle of the insights sync (spec 120 §4.1 step 2), on queue `analytics`. */
export const ANALYTICS_CYCLE_JOB_NAME = 'analytics-cycle';
/** One manual cycle per tenant at a time (AC-120-025). BullMQ job IDs must not contain ':'. */
export const manualAnalyticsCycleJobId = (tenantId) => `analytics-cycle-manual-${tenantId}`;
//# sourceMappingURL=analytics.js.map